export default {
    // 成功的token
    successCode: '00000',

    // token无效的错误码
    tokenInvalid: ['AU100', 'AU101'],
    // 访问路径
    cdn: 'https://pili-vod.bluedata.net.cn/',

    pageType: {
        NORMAL: 0,
        LOGIN: 1,
        REGISTER: 2,
        FIND: 3,
        REGISTER_CORP: 4,
    },

    tableSize: [
        {key: 'mini', value: '紧凑'},
        {key: 'small', value: '舒适'},
        {key: 'medium', value: '宽敞'},
    ],

    colType: {
        IMG: 1,
        SELECT: 2,
        DATE: 3,
        NUMBER: 4,
        NEDITOR: 5,
        FUZZY: 6
    },
}
